<template>
  <div
    :class="bem.b()"
    v-bind="containerAttrs"
    @mouseover="handleMouseOver"
    @mouseout="handleMouseOut"
  >
    <InputSearch
      v-bind="componentAttrs"
      ref="inputSearchRef"
      autocomplete="off"
      :class="{
        'show-clear-icon':
          props.allowClear && hasValue && isMouseOver && !props.disabled,
      }"
      :value="innerValue"
      :allow-clear="props.allowClear"
      :disabled="props.disabled"
      @change="onChange"
      @blur="onBlur"
    >
      <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
        <slot :name="item" v-bind="data || {}"></slot>
      </template>
    </InputSearch>
  </div>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { Form, InputSearch } from 'ant-design-vue'
import { omit } from 'lodash-es'
import { computed, ref, useAttrs, watch } from 'vue'
import { inputSearchProps, InputValue } from './input'

defineOptions({ name: 'LlInputSearch', inheritAttrs: false })

const props = defineProps(inputSearchProps)
const emits = defineEmits(['update:value', 'change', 'clear', 'blur'])

const attrs = useAttrs()

// 容器样式
const containerAttrs = computed(() => ({
  class: attrs.class as any,
  style: attrs.style as any,
}))

// 组件功能相关的属性
const componentAttrs = computed(() => omit(attrs, ['class', 'style']))

const bem = createNamespace('input-search')
const inputSearchRef = ref()
const innerValue = ref<InputValue>('')
const isMouseOver = ref(false)
const formItemContext = Form.useInjectFormItemContext()

// 判断当前输入框是否有值
const hasValue = computed(() => innerValue.value || props.defaultValue)

// 鼠标移入事件
const handleMouseOver = () => {
  isMouseOver.value = true
}

// 鼠标移出事件
const handleMouseOut = () => {
  isMouseOver.value = false
}
// 输入框发送变化的回调
const onChange = (e: any) => {
  const { value } = e.target
  emits('update:value', value)
  emits('change', e)
  if (!value && e.type === 'click') {
    emits('clear', value)
  }
  innerValue.value = value
  formItemContext.onFieldChange()
}

const onBlur = (e: any) => {
  emits('blur', e)
  formItemContext.onFieldBlur()
}

// 监听props.value/props.defaultValue的变化
watch(
  () => [props.value, props.defaultValue],
  ([newValue, newDefaultValue]) => {
    innerValue.value = newValue || newDefaultValue
  },
  {
    immediate: true,
  }
)

const focus = () => {
  inputSearchRef.value.focus()
}
const select = () => {
  inputSearchRef.value.select()
}

defineExpose({
  focus,
  select,
})
</script>
<!--  -->
